import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Send, Loader2, Mail, Flame, HandHelping } from "lucide-react";
import { Reveal, SectionHeading } from "./Atoms";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);
  const update = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
      toast.error("Please fill in your name, email, and message.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/contact-messages`, form);
      toast.success("Your message has been received. We'll be in touch.");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (err) {
      toast.error("We couldn't submit right now. Please try again shortly.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact" className="relative py-28 px-6 bg-[#050505]">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5">
          <Reveal>
            <SectionHeading
              overline="Reach the Ministry"
              title={<>Contact Revival Fire <span className="italic gold-text">Ministries Global</span></>}
              subtitle="Reach out for ministry inquiries, partnerships, or to share your testimony."
            />
          </Reveal>
          <Reveal delay={100}>
            <div className="space-y-3">
              <a
                href="mailto:rfmgcontact@gmail.com"
                className="flex items-center gap-3 text-[#F6F0E6] hover:text-[#C9A44C] transition-colors"
                data-testid="contact-email-link"
              >
                <span className="h-10 w-10 inline-flex items-center justify-center rounded-full border border-[#C9A44C]/30">
                  <Mail className="h-4 w-4 text-[#C9A44C]" strokeWidth={1.6} />
                </span>
                rfmgcontact@gmail.com
              </a>
              <div className="flex flex-wrap gap-3 pt-4">
                <a href="#prayer" className="btn-ghost !py-2.5 !px-4 !text-sm" data-testid="contact-quick-prayer">
                  <Flame className="h-3.5 w-3.5" strokeWidth={1.7} /> Request Prayer
                </a>
                <a href="#updates" className="btn-ghost !py-2.5 !px-4 !text-sm" data-testid="contact-quick-updates">
                  Join Updates
                </a>
                <a href="#give" className="btn-ghost !py-2.5 !px-4 !text-sm" data-testid="contact-quick-give">
                  <HandHelping className="h-3.5 w-3.5" strokeWidth={1.7} /> Give / Partner
                </a>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <Reveal>
            <form onSubmit={submit} className="bento-card !p-7 sm:!p-10 space-y-6" data-testid="contact-form">
              <span className="glow-blob" />
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                <div>
                  <label className="field-label">Name</label>
                  <input className="input-fire" data-testid="contact-name" value={form.name} onChange={(e) => update("name", e.target.value)} required />
                </div>
                <div>
                  <label className="field-label">Email</label>
                  <input type="email" className="input-fire" data-testid="contact-email" value={form.email} onChange={(e) => update("email", e.target.value)} required />
                </div>
              </div>
              <div>
                <label className="field-label">Subject</label>
                <input className="input-fire" data-testid="contact-subject" placeholder="What is this about?" value={form.subject} onChange={(e) => update("subject", e.target.value)} />
              </div>
              <div>
                <label className="field-label">Message</label>
                <textarea className="input-fire" data-testid="contact-message" rows={5} value={form.message} onChange={(e) => update("message", e.target.value)} required />
              </div>
              <button type="submit" className="btn-fire" disabled={loading} data-testid="contact-submit">
                {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" strokeWidth={1.7} />}
                {loading ? "Sending…" : "Send Message"}
              </button>
            </form>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Contact;
